// extracted by mini-css-extract-plugin
export var askAiIcon = "_k9-9";
export var container = "_k9-0";
export var groupSeparator = "_k9-a";
export var highlight = "_k9-4";
export var resultIcon = "_k9-5";
export var resultItem = "_k9-7";
export var resultSubtitle = "_k9-3";
export var resultTitle = "_k9-2";
export var resultsList = "_k9-1";
export var searchGroup = "_k9-6";
export var selected = "_k9-8";